import React, { FC } from 'react';
import { usePushNotification } from '../../hooks/usePushNotification';
import './notifications-section.scss';

const DISMISSED_KEY_PREFIX = 'push_notification_dismissed_';

const isPWA = (): boolean => {
  if (window.matchMedia('(display-mode: standalone)').matches) return true;
  if ((navigator as any).standalone === true) return true;
  return false;
};

const NotificationsSection: FC = () => {
  const {
    isSupported,
    isFullySetup,
    isDenied,
    isRequesting,
    requestPermissionAndSubscribe,
    unsubscribe,
  } = usePushNotification();

  const handleEnable = async () => {
    // Clear any previous "Not now" dismissal so the modal doesn't interfere
    try {
      const key = DISMISSED_KEY_PREFIX + (isPWA() ? 'pwa' : 'web');
      localStorage.removeItem(key);
    } catch {
      // ignore
    }
    await requestPermissionAndSubscribe();
  };

  const handleDisable = async () => {
    await unsubscribe();
  };

  if (!isSupported) {
    return (
      <div className='notifications-section'>
        <div className='notifications-header'>
          <h2 className='section-title'>Notifications</h2>
          <p className='notifications-subtitle'>
            Push notifications are not supported on this device or browser.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className='notifications-section'>
      <div className='notifications-header'>
        <h2 className='section-title'>Notifications</h2>
        <p className='notifications-subtitle'>
          Get notified when your Dreamie needs your input — even when you're not
          in the app.
        </p>
      </div>

      <div className='notifications-card'>
        <div className='notifications-row'>
          <div className='notifications-row-info'>
            <span className='notifications-row-label'>Push notifications</span>
            <span className='notifications-row-status'>
              {isDenied
                ? 'Blocked in browser settings'
                : isFullySetup
                  ? 'Enabled'
                  : 'Disabled'}
            </span>
          </div>

          {isDenied ? (
            <p className='notifications-hint'>
              Notifications are blocked. Please enable them in your browser or
              device settings for this site.
            </p>
          ) : isFullySetup ? (
            <button
              className='btn-notification-toggle off'
              onClick={handleDisable}
              disabled={isRequesting}
            >
              {isRequesting ? 'Disabling...' : 'Disable'}
            </button>
          ) : (
            <button
              className='btn-notification-toggle on'
              onClick={handleEnable}
              disabled={isRequesting}
            >
              {isRequesting ? 'Enabling...' : 'Enable'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default NotificationsSection;
